import { AdminCertificatesSettingsModalActionsProps } from "../../../../models/admin-certificates-settings.models";
import { CheckIcon } from "@heroicons/react/24/outline";

const AdminCertificatesSettingsModalActions = ({ saving, onCancel }: AdminCertificatesSettingsModalActionsProps) => (
  <footer className="flex items-center justify-end gap-2 border-t border-gray-200 px-5 py-3 dark:border-gray-700">
    <button
      type="button"
      data-test="admin-certificates-settings-modal-cancel"
      disabled={saving}
      onClick={onCancel}
      className="h-10 border border-gray-300 px-4 text-sm font-semibold disabled:opacity-50 dark:border-gray-700"
    >
      Cancel
    </button>
    <button
      type="submit"
      data-test="admin-certificates-settings-modal-save"
      disabled={saving}
      className="inline-flex h-10 items-center gap-2 bg-green px-4 text-sm font-semibold text-white transition-colors hover:bg-[#166b60] disabled:cursor-not-allowed disabled:opacity-50"
    >
      <CheckIcon className="h-5 w-5" />
      {saving ? "Saving" : "Save"}
    </button>
  </footer>
);

export default AdminCertificatesSettingsModalActions;
